export interface MoodProps {
    moodName: string;
    moodImage: string;
    onSelect: () => void;
}

const Mood = ({ moodName, moodImage, onSelect }: MoodProps) => {

    return (
        <li className="mood_item">
            <a onClick={onSelect} href="#" className="mood_link w-inline-block">
                <div className="mood_pict_block">
                    <img
                        src={moodImage}
                        loading="lazy"
                        alt=""
                        className="mood_pict"
                    />
                </div>
                <div>{moodName}</div>
            </a>
        </li>
    )

}

export default Mood;